// PeptideVault v6.5 — Peptides tab + detail

// ══════════════════════════════════════════════════════
// RENDER: PEPTIDES TAB
// ══════════════════════════════════════════════════════
function renderPeptidesTab() {
  if (S.selectedPeptide) return renderPeptideDetail()
  
  const filtered = S.search
    ? S.peptides.filter(p => p.name.toLowerCase().includes(S.search.toLowerCase()) || (p.customVialName||'').toLowerCase().includes(S.search.toLowerCase()))
    : [...S.peptides]
  filtered.sort((a,b) => a.name.localeCompare(b.name))
  const lsp = lowStockPeptides()

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:18px">
      <h2 style="font-size:20px;font-weight:700">Peptide Inventory</h2>
      <div class="spacer"></div>
      <input class="form-input" style="width:220px" placeholder="Search peptides…" value="${esc(S.search)}" oninput="S.search=this.value;render()">
      <button class="btn btn-secondary" onclick="importPeptideCSV()">${ICONS.plus} Import CSV</button>
      <button class="btn btn-primary" onclick="openModal('addPeptide')">${ICONS.plus} Add Peptide</button>
      <button class="btn btn-secondary btn-sm" onclick="downloadSkuImportTemplate()">SKU Template</button>
      <button class="btn btn-secondary btn-sm" onclick="importSkuCSV()">Import SKUs</button>
    </div>

    ${lsp.length ? `
    <div class="alert-bar">
      <span style="color:var(--yellowT)">${ICONS.warning}</span>
      <div style="flex:1">
        <strong style="font-size:13px;color:var(--yellowT)">${lsp.length} peptide${lsp.length>1?'s':''} need attention</strong>
        <div style="font-size:12px;color:var(--text3);margin-top:3px;display:flex;flex-direction:column;gap:2px">
          ${lsp.map(p=>{
            const q = peptideQty(p)
            const thr = +(p.lowStockThreshold||0)
            const hasSkus = (p.skus||[]).length > 0
            let reason
            if (!hasSkus) reason = 'no SKUs added yet'
            else if (q <= 0) reason = 'out of stock'
            else reason = `low: ${q} ${p.unit||'units'} (threshold ${thr})`
            return `<div><strong style="cursor:pointer;text-decoration:underline" onclick="selectPeptide('${p.id}')">${esc(p.name)}</strong> — ${reason}</div>`
          }).join('')}
        </div>
      </div>
    </div>` : ''}

    <div class="card">
      ${filtered.length === 0 ? `
        <div class="empty-state">
          <div class="empty-icon">💊</div>
          <p>${S.search ? 'No results found' : 'No peptides yet'}</p>
          <span>${S.search ? 'Try a different search term' : 'Click "Add Peptide" to get started'}</span>
        </div>
      ` : `
        <div>
          ${filtered.map(p => {
            const qty = peptideQty(p)
            const skuCount = (p.skus||[]).length
            const thr = +(p.lowStockThreshold||0)
            const rowFlag = p.archived ? 'border-left:3px solid var(--text4);opacity:.55'
              : (qty <= 0 ? 'border-left:3px solid var(--red)' : (thr && qty <= thr ? 'border-left:3px solid var(--yellow)' : 'border-left:3px solid transparent'))
            return `
            <div class="peptide-row" onclick="selectPeptide('${p.id}')" style="${rowFlag}">
              <div>
                <div class="pep-name">${esc(p.name)}</div>
                ${(p.customVialName || findLibraryEntry(p.name)?.customVialName) ?
                  `<div style="font-size:11px;color:var(--blue2);font-style:italic;margin-top:1px">${esc(p.customVialName || findLibraryEntry(p.name)?.customVialName)}</div>` : ''}
                <div class="pep-meta">${skuCount} SKU${skuCount!==1?'s':''} · ${p.unit||'units'}</div>
              </div>
              <div style="text-align:right">
                <div style="font-size:20px;font-weight:700;color:var(--text)">${qty}<span style="font-size:13px;font-weight:400;color:var(--text3);margin-left:3px">${p.unit||''}</span></div>
                <div style="font-size:11px;color:var(--text4)">total qty</div>
              </div>
              <div>${statusBadge(p)}</div>
            </div>`
          }).join('')}
        </div>
      `}
    </div>
  </div>`
}

// ══════════════════════════════════════════════════════
// RENDER: PEPTIDE DETAIL
// ══════════════════════════════════════════════════════
function renderBlendBadges(p) {
  const spans = p.blendComponents.map(c => {
    const compPep = getPeptide(c.peptideId) || S.peptides.find(x => x.name === c.peptideName)
    const hl = (c.halfLife && +c.halfLife > 0) ? c.halfLife
             : (compPep?.halfLife && +compPep.halfLife > 0) ? compPep.halfLife : null
    const hlLabel = hl ? ' · t½=' + hl + 'h' : ''
    return '<span style="background:rgba(255,255,255,.6);border-radius:20px;padding:3px 10px;font-size:12px;font-weight:600;color:var(--purpleT)">'
      + esc(c.peptideName)
      + (hlLabel ? '<span style="opacity:.7;font-weight:400">' + hlLabel + '</span>' : '')
      + '</span>'
  }).join('')
  return '<div style="background:var(--purpleL);border-radius:var(--r2);padding:10px 12px;margin-bottom:10px">'
    + '<div style="font-size:11px;font-weight:700;color:var(--purpleT);text-transform:uppercase;letter-spacing:.4px;margin-bottom:6px">Blend Components</div>'
    + '<div style="display:flex;flex-wrap:wrap;gap:6px">' + spans + '</div>'
    + '</div>'
}
function renderPeptideDetail() {
  const p = getPeptide(S.selectedPeptide)
  if (!p) { S.selectedPeptide = null; return renderPeptidesTab() }
  const totalQty = peptideQty(p)

  return `
  <div style="animation:fadeIn .2s ease">
    <!-- Breadcrumb -->
    <div class="row" style="margin-bottom:18px">
      <button class="btn btn-ghost btn-sm" onclick="S.selectedPeptide=null;S._restoreListScroll=true;render()">← Back</button>
      <span style="color:var(--text4);font-size:13px">/</span>
      <span style="font-size:13px;font-weight:600;color:var(--text)">${esc(p.name)}</span>
      <div class="spacer"></div>
      <button class="btn btn-secondary btn-sm" onclick="openModal('editPeptide',{pid:'${p.id}'})">${ICONS.edit} Edit</button>
      <button class="btn btn-ghost btn-sm" onclick="togglePeptideArchived('${p.id}')">${p.archived ? '↑ Reactivate' : '⊘ Mark Inactive'}</button>
      <button class="btn btn-danger btn-sm" onclick="deletePeptide('${p.id}')">${ICONS.trash}</button>
    </div>

    <!-- Header card -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-body">
        <div class="row" style="align-items:flex-start;gap:16px;flex-wrap:wrap">
          <div style="flex:1;min-width:260px">
            <div class="row" style="margin-bottom:8px;gap:10px;flex-wrap:wrap">
              <h2 style="font-size:22px;font-weight:700">${esc(p.name)}</h2>
              ${statusBadge(p)}
              ${p.pepPediaUrl ? `<button class="peppedia-btn" onclick="openPepPedia('${esc(p.pepPediaUrl)}')">${ICONS.globe} Pep-Pedia</button>` : ''}
            </div>
            ${(p.customVialName || findLibraryEntry(p.name)?.customVialName) ?
              `<div style="font-size:14px;color:var(--blue2);font-style:italic;margin-bottom:8px">${esc(p.customVialName || findLibraryEntry(p.name)?.customVialName)}</div>` : ''}
            ${p.isBlend && p.blendComponents?.length ? renderBlendBadges(p) : ''}
            ${(p.categories||[]).length ? `<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:8px">${p.categories.map(c => `<span class="badge" style="background:${categoryColor(c)}22;color:${categoryColor(c)}">${esc(c)}</span>`).join('')}</div>` : ''}
            ${p.halfLife && !p.isBlend ? `<div style="font-size:12px;color:var(--text3);margin-bottom:6px">t½ = <strong>${p.halfLife}h</strong> · ka = ${p.absorptionRate||0.8}/h (SubQ)</div>` : ''}
            ${p.notes ? `<div style="font-size:13px;color:var(--text2);font-style:italic">${esc(p.notes)}</div>` : ''}
          </div>
          <div class="detail-grid" style="flex-shrink:0;min-width:280px">
            <div class="detail-item"><div class="detail-label">Total Qty</div><div class="detail-value" style="font-size:18px;font-weight:700;color:var(--blue)">${totalQty} <span style="font-size:13px;color:var(--text3)">${p.unit||''}</span></div></div>
            <div class="detail-item"><div class="detail-label">Unit</div><div class="detail-value">${esc(p.unit||'—')}</div></div>
            ${p.lowStockThreshold ? `<div class="detail-item" style="grid-column:1/-1"><div class="detail-label">Low Stock Alert</div><div class="detail-value">&lt; ${p.lowStockThreshold} ${p.unit||'units'}</div></div>` : ''}
          </div>
        </div>
      </div>
    </div>

    <!-- SKUs -->
    <div class="section-hd">
      <h3>${ICONS.vial} SKUs / Lots</h3>
      <button class="btn btn-primary btn-sm" onclick="openModal('addSku',{pid:'${p.id}'})">${ICONS.plus} Add SKU</button>
    </div>
    ${(p.skus||[]).length === 0 ? `<div style="color:var(--text4);font-size:13px;margin-bottom:20px">No SKUs yet. Add one to start tracking inventory.</div>` :
      (p.skus||[]).map(s => renderSkuCard(p, s)).join('')}

    <div class="divider"></div>

    <!-- Injection Calendar -->
    <div class="section-hd" style="margin-top:4px">
      <h3>${ICONS.calendar} Injection Schedule</h3>
      <button class="btn btn-ghost btn-sm" onclick="setTab('calendar')" style="font-size:12px">View all →</button>
    </div>
    ${injectionsForPeptide(p.id, p.name).length === 0
      ? `<div style="color:var(--text4);font-size:13px;margin-bottom:16px">No injections recorded — import a CSV from the Calendar tab.</div>`
      : renderMiniCalendar(p.id, p.name) + '<div style="margin-bottom:16px"></div>'}

    <div class="divider"></div>

    <!-- Linked Protocol Documents -->
    <div class="section-hd" style="margin-top:4px">
      <h3>Linked Protocol Documents</h3>
      <button class="btn btn-secondary btn-sm" onclick="openModal('linkProtocol',{pid:'${p.id}'})">${ICONS.link} Link Protocol</button>
    </div>
    ${(p.protocolDocIds||[]).length === 0 ? `<div style="color:var(--text4);font-size:13px;margin-bottom:16px">No protocol documents linked.</div>` :
      `<div style="display:flex;flex-direction:column;gap:8px;margin-bottom:16px">
        ${p.protocolDocIds.map(did => {
          const doc = getDoc(did)
          if (!doc) return ''
          return `<div class="row" style="background:var(--bg3);border:1px solid var(--border);border-radius:var(--r2);padding:10px 14px">
            <span class="doc-type-badge ${docTypeClass(doc.type)}">${docTypeName(doc.type)}</span>
            <span style="font-size:13px;font-weight:500;flex:1;margin-left:8px">${esc(doc.name)}</span>
            <button class="btn btn-ghost btn-xs" onclick="openDocFile(getDoc('${did}'))">${ICONS.eye} Open</button>
            <button class="btn btn-danger btn-xs" onclick="unlinkProtocolDoc('${p.id}','${did}')">${ICONS.unlink}</button>
          </div>`
        }).join('')}
      </div>`}
  </div>`
}

function renderSkuCard(p, s) {
  const qty = skuQty(s)
  const mappedQty = (S.vaultAssignments || []).filter(a => a.skuId === s.id).reduce((sum,a) => sum + Math.max(0, +(a.qty || 0)), 0)
  const mapOverage = Math.max(0, mappedQty - qty)
  const skuDocIds = (s.coaDocIds || []).concat(s.coaDocId ? [s.coaDocId] : [])
  const linkedCoas = (S.coas || []).filter(c =>
    (c.lotIds || []).includes(s.id) ||
    (s.lotNumber && (c.lotIds || []).includes(s.lotNumber)) ||
    (c.documentId && skuDocIds.includes(c.documentId))
  )
  return `
  <div class="sku-card" style="margin-bottom:10px">
    <div class="row" style="margin-bottom:10px">
      <div>
        ${s.barcode ? `<div class="sku-barcode">▌ ${esc(s.barcode)}</div>` : '<div class="sku-barcode" style="color:var(--text4)">No barcode</div>'}
        <div style="font-size:12px;color:var(--text3);margin-top:2px">${esc(s.vendor||'—')} · Lot: ${esc(s.lotNumber||'—')}${s.capColor ? ` · Cap: ${esc(s.capColor)}` : ''}</div>
      </div>
      <div class="spacer"></div>
      <div style="text-align:right;margin-right:12px">
        <div style="font-size:18px;font-weight:700;color:${qty<=0?'var(--red)':qty<3?'var(--yellow)':'var(--text)'}">${qty}</div>
        <div style="font-size:11px;color:var(--text4)">vials</div>
      </div>
      <div class="row" style="gap:4px">
        <button class="btn btn-ghost btn-xs" onclick="openModal('editSku',{pid:'${p.id}',sid:'${s.id}'})">${ICONS.edit}</button>
        <button class="btn btn-danger btn-xs" onclick="deleteSku('${p.id}','${s.id}')">${ICONS.trash}</button>
      </div>
    </div>
    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:8px;margin-bottom:10px">
      ${s.purity ? `<div><div class="detail-label">Purity</div><div style="font-size:13px">${esc(s.purity)}</div></div>` : ''}
      ${formatVialStrength(s) ? `<div><div class="detail-label">Vial Strength</div><div style="font-size:13px;font-weight:600">${esc(formatVialStrength(s))}</div></div>` : ''}
      ${(s.testedConcentration||s.concentration) ? `<div><div class="detail-label">Tested Concentration</div><div style="font-size:13px">${esc(s.testedConcentration||s.concentration)}</div></div>` : ''}
      ${s.expiryDate ? `<div><div class="detail-label">Expiry</div><div style="font-size:13px;color:${new Date(s.expiryDate)<new Date()?'var(--red)':'var(--text)'}">${fmt(s.expiryDate)}</div></div>` : ''}
      ${s.costPerVial ? `<div><div class="detail-label">Cost/Vial</div><div style="font-size:13px">${fmtCur(s.costPerVial)}${s.dosesPerVial ? ` <span style="color:var(--text4);font-size:11px">(${s.dosesPerVial} doses → ${fmtCur((+s.costPerVial/+s.dosesPerVial).toFixed(2))}/inj)</span>` : ''}</div></div>` : ''}
    </div>
    ${s.isBlend && s.blendComponents?.length ? `
    <div style="background:var(--purpleL);border-radius:6px;padding:8px 10px;margin-bottom:8px">
      <div style="font-size:11px;font-weight:700;color:var(--purpleT);margin-bottom:4px">BLEND</div>
      ${s.blendComponents.map(c=>`<div style="font-size:12px;color:var(--text2)">${esc(c.peptide)} — ${esc(c.vialStrength)}</div>`).join('')}
    </div>` : ''}
    ${mapOverage ? `<div class="alert-bar" style="margin:0 0 8px;padding:8px 10px">
      <div style="flex:1;font-size:12px"><strong>Vault map needs reconciliation</strong><div style="color:var(--text3);margin-top:2px">The map contains ${mappedQty} vials, but inventory contains ${qty}. Choose where the ${mapOverage} removed vial${mapOverage!==1?'s':''} came from.</div></div>
      <button class="btn btn-secondary btn-xs" onclick="reconcileVaultRemoval('${p.id}','${s.id}')">Choose holder${mapOverage!==1?'s':''}</button>
    </div>` : ''}
    <div class="row" style="gap:8px;flex-wrap:wrap">
      <!-- Qty trackers -->
      <div class="row" style="gap:6px;background:var(--bg2);border:1px solid var(--border);border-radius:var(--r2);padding:6px 10px">
        <span style="font-size:12px;color:var(--text3)">Add:</span>
        <input type="number" class="form-input" style="width:64px;padding:4px 8px" min="0" value="1" id="in_${s.id}" onclick="event.stopPropagation()">
        <button class="btn btn-success btn-xs" onclick="recordTx('${p.id}','${s.id}','in')">+ In</button>
      </div>
      <div class="row" style="gap:6px;background:var(--bg2);border:1px solid var(--border);border-radius:var(--r2);padding:6px 10px">
        <span style="font-size:12px;color:var(--text3)">Remove:</span>
        <input type="number" class="form-input" style="width:64px;padding:4px 8px" min="0" value="1" id="out_${s.id}" onclick="event.stopPropagation()">
        <button class="btn btn-danger btn-xs" onclick="recordTx('${p.id}','${s.id}','out')">− Out</button>
      </div>
      ${linkedCoas.length ? `<button class="btn btn-secondary btn-sm" onclick="openCoaForSku('${s.id}')">${ICONS.eye} COA${linkedCoas.length > 1 ? ` (${linkedCoas.length})` : ''}</button>` : ''}
    </div>
  </div>`
}

function renderDosageCard(pid, dp) {
  const statusColors = { active:'var(--green)', planned:'var(--blue)', past:'var(--text4)' }
  const statusBg = { active:'badge-green', planned:'badge-blue', past:'badge-gray' }
  const freqLabel = { daily:'Daily', twice_daily:'Twice Daily', eod:'Every Other Day', three_week:'3x / Week', weekly:'Weekly', biweekly:'Biweekly' }
  return `
  <div class="dp-card" style="margin-bottom:8px">
    <div class="dp-status-bar" style="background:${statusColors[dp.status]||'var(--text4)'}"></div>
    <div style="flex:1">
      <div class="row" style="margin-bottom:5px">
        <strong style="font-size:13px">${esc(dp.name)}</strong>
        <span class="badge ${statusBg[dp.status]||'badge-gray'}" style="font-size:10px">${dp.status}</span>
        <div class="spacer"></div>
        <button class="btn-icon btn-sm" onclick="openModal('editDosage',{pid:'${pid}',dpid:'${dp.id}'})">${ICONS.edit}</button>
        <button class="btn-icon btn-sm" style="color:var(--red)" onclick="deleteDosage('${pid}','${dp.id}')">${ICONS.trash}</button>
      </div>
      <div style="display:flex;gap:12px;flex-wrap:wrap">
        <span style="font-size:13px;font-weight:600;color:var(--blue)">${esc(dp.dose)} ${esc(dp.doseUnit)}</span>
        <span style="font-size:12px;color:var(--text3)">${freqLabel[dp.frequency]||dp.frequency}</span>
        ${dp.duration ? `<span style="font-size:12px;color:var(--text3)">${esc(dp.duration)}</span>` : ''}
        ${dp.route ? `<span style="font-size:12px;color:var(--text3)">${esc(dp.route)}</span>` : ''}
      </div>
      ${dp.notes ? `<div style="font-size:12px;color:var(--text4);margin-top:4px;font-style:italic">${esc(dp.notes)}</div>` : ''}
    </div>
  </div>`
}

export {
  renderPeptidesTab,
  renderBlendBadges,
  renderPeptideDetail,
  renderSkuCard,
  renderDosageCard
}
